import React from 'react';
import {
  EthDarkCircle,
  EthLightCircle,
  EthIcon,
  EthDarkIcon,
  EthBlueIcon,
  EthRedIcon,
  EthereumPurpleIcon,
  NRGLogoInvertedIcon,
  NRGLogoDarkIcon,
  NRGLogoLightIcon,
  NRGLogoInvertedDarkIcon,
  NRGLogoInvertedLightIcon,
  NRGLogoIcon,
  EnergiIconCustom,
  ApeChainDarkCircle,
  ApeChainLightCircle,
  ApeChainIconLight,
  ApeChainDarkIcon,
  ApeChainBlueIcon,
  ApeChainRedIcon,
  ApeChainSymbol,
  BerachainDarkCircle,
  BerachainLightCircle,
  BerachainIconLight,
  BerachainDarkIcon,
  BerachainBlueIcon,
  BerachainRedIcon,
  BerachainSymbol,
  BaseDarkCircle,
  BaseLightCircle,
  BaseSymbol,
  SoneiumDarkCircle,
  SoneiumLightCircle,
  SoneiumIconLight,
  SoneiumDarkIcon,
  SoneiumBlueIcon,
  SoneiumRedIcon,
  SoneiumSymbol,
  AbstractDarkCircle,
  AbstractLightCircle,
  AbstractIconLight,
  AbstractDarkIcon,
  AbstractBlueIcon,
  AbstractRedIcon,
  AbstractSymbol,
  ShibariumDarkCircle,
  ShibariumLightCircle,
  ShibariumIconLight,
  ShibariumDarkIcon,
  ShibariumBlueIcon,
  ShibariumRedIcon,
  ShibariumSymbol,
  TenDarkCircle,
  TenLightCircle,
  TenIcon,
  TenDarkIcon,
  TenBlueIcon,
  TenRedIcon,
  TenSymbol,
  MonadDarkCircle,
  MonadLightCircle,
  MonadIcon,
  MonadDarkIcon,
  MonadBlueIcon,
  MonadRedIcon,
  MonadSymbol,
} from 'components/ImageComponent';
import useWalletContext from 'hooks/useWalletContext';

const CHAIN_CURRENCIES = {
  1: 'ETH',
  11155111: 'ETH',
  39797: 'NRG',
  49797: 'NRG',
  84532: 'ETH',
  8453: 'BASE', // Use Base branding on Base chains
  33139: 'APE',
  33111: 'APE',
  80094: 'BERA',
  80069: 'BERA',
  1868: 'SONEIUM_ETH', // Use Soneium branding on Soneium chains
  1946: 'SONEIUM_ETH',
  2741: 'ABSTRACT_ETH', // Abstract Mainnet
  11124: 'ABSTRACT_ETH', // Abstract Testnet
  109: 'SHIBARIUM_BONE', // Shibarium Mainnet
  157: 'SHIBARIUM_BONE', // Puppynet Testnet
  443: 'TEN_ETH', // TEN Testnet - use TEN branding
  10143: 'MONAD_MON', // Monad Testnet - use Monad branding
};

export const CurrencyIcon = ({ props = {}, currency, type = 'default' }) => {
  const { storedChain } = useWalletContext();

  const targetCurrency = currency ?? CHAIN_CURRENCIES[storedChain];

  return {
    ETH: {
      circleDark: <EthDarkCircle {...props} />,
      circleLight: <EthLightCircle {...props} />,
      light: <EthIcon {...props} />,
      dark: <EthDarkIcon {...props} />,
      default: <EthBlueIcon {...props} />,
      current: <EthRedIcon {...props} />,
      symbol: <EthereumPurpleIcon {...props} />,
    },
    NRG: {
      circleDark: <NRGLogoInvertedDarkIcon {...props} />,
      circleLight: <NRGLogoInvertedLightIcon {...props} />,
      light: <NRGLogoLightIcon {...props} />,
      dark: <NRGLogoDarkIcon {...props} />,
      default: <NRGLogoIcon {...props} />,
      current: <NRGLogoInvertedIcon {...props} />,
      symbol: <EnergiIconCustom {...props} />,
    },
    APE: {
      circleDark: <ApeChainDarkCircle {...props} />,
      circleLight: <ApeChainLightCircle {...props} />,
      light: <ApeChainIconLight {...props} />,
      dark: <ApeChainDarkIcon {...props} />,
      default: <ApeChainBlueIcon {...props} />,
      current: <ApeChainRedIcon {...props} />,
      symbol: <ApeChainSymbol {...props} />,
    },
    BERA: {
      circleDark: <BerachainDarkCircle {...props} />,
      circleLight: <BerachainLightCircle {...props} />,
      light: <BerachainIconLight {...props} />,
      dark: <BerachainDarkIcon {...props} />,
      default: <BerachainBlueIcon {...props} />,
      current: <BerachainRedIcon {...props} />,
      symbol: <BerachainSymbol {...props} />,
    },
    BASE: {
      circleDark: <BaseDarkCircle {...props} />,
      circleLight: <BaseLightCircle {...props} />,
      light: <BaseSymbol {...props} />,
      dark: <BaseSymbol {...props} />,
      default: <BaseSymbol {...props} />,
      current: <BaseSymbol {...props} />,
      symbol: <BaseSymbol {...props} />,
    },
    SONEIUM_ETH: {
      circleDark: <SoneiumDarkCircle {...props} />,
      circleLight: <SoneiumLightCircle {...props} />,
      light: <SoneiumIconLight {...props} />,
      dark: <SoneiumDarkIcon {...props} />,
      default: <SoneiumBlueIcon {...props} />,
      current: <SoneiumRedIcon {...props} />,
      symbol: <SoneiumSymbol {...props} />,
    },
    ABSTRACT_ETH: {
      circleDark: <AbstractDarkCircle {...props} />,
      circleLight: <AbstractLightCircle {...props} />,
      light: <AbstractIconLight {...props} />,
      dark: <AbstractDarkIcon {...props} />,
      default: <AbstractBlueIcon {...props} />,
      current: <AbstractRedIcon {...props} />,
      symbol: <AbstractSymbol {...props} />,
    },
    SHIBARIUM_BONE: {
      circleDark: <ShibariumDarkCircle {...props} />,
      circleLight: <ShibariumLightCircle {...props} />,
      light: <ShibariumIconLight {...props} />,
      dark: <ShibariumDarkIcon {...props} />,
      default: <ShibariumBlueIcon {...props} />,
      current: <ShibariumRedIcon {...props} />,
      symbol: <ShibariumSymbol {...props} />,
    },
    TEN_ETH: {
      circleDark: <TenDarkCircle {...props} />,
      circleLight: <TenLightCircle {...props} />,
      light: <TenIcon src={require('assets/images/tenChain.jpg')} alt="TEN" {...props} />,
      dark: <TenDarkIcon src={require('assets/images/tenChain.jpg')} alt="TEN" {...props} />,
      default: <TenBlueIcon src={require('assets/images/tenChain.jpg')} alt="TEN" {...props} />,
      current: <TenRedIcon src={require('assets/images/tenChain.jpg')} alt="TEN" {...props} />,
      symbol: <TenSymbol src={require('assets/images/tenChain.jpg')} alt="TEN" {...props} />,
    },
    MONAD_MON: {
      circleDark: <MonadDarkCircle {...props} />,
      circleLight: <MonadLightCircle {...props} />,
      light: <MonadIcon {...props} />,
      dark: <MonadDarkIcon {...props} />,
      default: <MonadBlueIcon {...props} />,
      current: <MonadRedIcon {...props} />,
      symbol: <MonadSymbol {...props} />,
    },
  }[targetCurrency]?.[type];
};
